module.exports = __webpack_public_path__ + "h5/img/dfk@3x.2352fde9.png";